import { jsPDF } from "jspdf";
import type { State } from "../State";
import { projectGeneralNotes } from "./technicalReports/notes";
import { loadPdfDocumentHeader } from "./PdfDocumentHeader";
import { registerC1PdfFonts } from "../../ConceptOne/src/lib/C1_PdfFonts";

/** Renders the shared explanatory page once, fitting all applicable notes onto one A4 page. */
export async function createGeneralNotesPdf(app: State, chapterIds: readonly string[], projectName: string): Promise<Blob> {
  const doc = new jsPDF({ unit: "pt", format: "a4", compress: true });
  await registerC1PdfFonts(doc);
  const header = await loadPdfDocumentHeader(app);
  const width = doc.internal.pageSize.getWidth(), height = doc.internal.pageSize.getHeight();
  const notes = projectGeneralNotes(app, chapterIds);
  let fontSize = 10;
  doc.setFont("helvetica", "normal"); doc.setFontSize(fontSize);
  let paragraphs = notes.map(note => doc.splitTextToSize(note, width - 90) as string[]);
  const textHeight = () => paragraphs.reduce((sum, lines) => sum + lines.length * fontSize * 1.25 + 9, 0);
  while (textHeight() > height - 150 && fontSize > 5) {
    fontSize -= 0.25; doc.setFontSize(fontSize);
    paragraphs = notes.map(note => doc.splitTextToSize(note, width - 90) as string[]);
  }
  if (textHeight() > height - 150) throw new Error("Die allgemeinen Hinweise passen nicht auf eine Seite.");
  header.draw(doc, { planType: "Allgemeine Hinweise", hierarchy: ["", ""] });
  doc.setFont("helvetica", "normal"); doc.setFontSize(fontSize);
  let y = 98;
  for (const lines of paragraphs) {
    doc.text(lines, 45, y, { lineHeightFactor: 1.25 });
    y += lines.length * fontSize * 1.25 + 9;
  }
  doc.setDrawColor("#aeb9bf"); doc.line(45, height - 35, width - 45, height - 35);
  doc.setFontSize(7); doc.setTextColor("#586a75");
  doc.text(doc.splitTextToSize(projectName, width - 90)[0] || "", 45, height - 22);
  return doc.output("blob");
}
